import { useCallback } from "react"
import { useComputed } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { capitalize, isEmpty, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { formData, loadingRow, tableData } from "../@signals"


export default function useAdminBrandModal() {
    const { showToast } = useAppToast()

    const isOpen = useComputed(() => !isEmpty(formData.value))
    const isCreate = useComputed(() => formData.value.brandID === null)

    const handleClose = useCallback(() => {
        formData.value = {}
    }, [])

    const handleSend = useCallback(() => {
        if (!formData.value.customerIDs?.length) {
            showToast.error("Please select at least one customer")
            return
        }

        loadingRow.value = formData.value.brandID
        showToast.promise(postSubmit(`${BACKEND_APIS.BRANDS}/crud/update-brand`, formData.value).then(res => {
            // Backend returns { error } (HTTP 200) when the brand name already
            // exists — reject with that message so the toast surfaces it and
            // the row is not added to the table.
            if (res?.error) return Promise.reject(res.error)
            loadingRow.value = null

            if (isCreate.value) {
                tableData.value = [...tableData.value, {
                    brandID: res.brandID,
                    brandName: res.brandName,
                    displayName: res.displayName || capitalize(res.brandName),
                    companyID: res.companyID,
                    companyName: res.companyName,
                    color: res.color,
                    validated: res.validated,
                    keyword: res.keyword,
                    excludedWord: res.excludedWord,
                    wholeWord: res.wholeWord,
                    customers: [],
                    customerIDs: formData.value.customerIDs || [],
                    customerAvailability: res.customerAvailability || []
                }]
            } else {
                tableData.value = tableData.value.map(dataRow => dataRow.brandID === res.brandID ? {
                    ...dataRow,
                    brandID: res.brandID,
                    brandName: res.brandName,
                    displayName: res.displayName || capitalize(res.brandName),
                    companyID: res.companyID,
                    companyName: res.companyName,
                    color: res.color,
                    validated: res.validated,
                    keyword: res.keyword,
                    excludedWord: res.excludedWord,
                    wholeWord: res.wholeWord,
                    customerAvailability: res.customerAvailability || []
                } : dataRow)
            }
        }), {
            success: isCreate.value ? "Brand created successfully" : "Brand updated successfully",
            loading: isCreate.value ? "Creating..." : "Updating...",
            onError: data => {
                loadingRow.value = null
                return typeof data === 'string' ? data : undefined
            }
        })
    }, [])

    return {
        isOpen: isOpen.value,
        isCreate: isCreate.value,

        handleClose,
        handleSend
    }
}
